module.exports = __webpack_public_path__ + "img/Sinarmas Hana Finance.758b03e5.png";